export const maskIban = (iban) => {
    if (!iban || iban.length < 6) return "****";
    return `${iban.slice(0, 4)} **** **** ${iban.slice(-4)}`;
};